module.exports = __webpack_public_path__ + "static/img/logo.7d55a9c3.png";